import { createFileRoute } from '@tanstack/react-router';
import { ProcessChainsOverviewPage } from '@/pages/processes/process-chains';

export const Route = createFileRoute('/$slug/processes/process-chains/')({
  component: ProcessChainsOverviewPage
});
